import React, { useContext } from 'react';
import CartItem from '../CartItem';
import CartContext from '../../context/CartContext';
import './index.css';

const CartListView = () => {
  const value = useContext(CartContext);
  const { cartList } = value;

  return (
    <ul className="cart-list">
      {cartList.map((eachCartItem) => (
        <CartItem key={eachCartItem.id} cartItemDetails={eachCartItem} />
      ))}
    </ul>
  );
};

export default CartListView;
